import { Link } from "react-router-dom";
import homeBg from "../img/home.jpg";
import "./home.css";

function home() {
  return (
    <main className="home">
      <div className="home__bg" style={{ backgroundImage: `url(${homeBg})` }} />

      <section className="home__wrap">
        <h1 className="home__name"> Jamile Prates</h1>

        <h2 className="home__headline">
          Discover the option <br />
          that suits you best
        </h2>

        <p className="home__bio">
          I&apos;ve recently moved to Australia and I&apos;m now bringing my
          passion for eyelash extensions to Sydney. With over 3 years of
          experience, I love helping women feel even more confident and
          beautiful.
        </p>

        <Link to="/catalog" className="home__cta">
          See Options
        </Link>
      </section>
    </main>
  );
}

export default home;
